import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63df024e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "minor-card__inner-wrapper" }
const _hoisted_2 = { class: "minor-card__content card-content" }
const _hoisted_3 = {
  key: 0,
  class: "card-content__icon-wrapper"
}
const _hoisted_4 = { class: "card-content__labels" }
const _hoisted_5 = { class: "card-content__title" }
const _hoisted_6 = {
  key: 0,
  class: "card-content__description"
}
const _hoisted_7 = { class: "minor-card__button" }

import MaterialShapedButton from '@/common/components/helper-components/material-shape-container/material-shaped-button/material-shaped-button.vue';
import googleMaterialIcon from '@/common/components/helper-components/google-material-icon/google-material-icon.vue';

import { IMinorCardProps } from './minor-card.types';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'minor-card',
  props: {
    props: null
  },
  setup(__props: any) {

const prop = __props as {
    props: IMinorCardProps;
};



const clicked = () => {
    if (prop.props.to) {
        router.push(prop.props.to);
    } else if (prop.props.href) {
        window.location.href = prop.props.href;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "minor-card material-card-minor_type_filled-clickable",
    href: "#",
    onClick: clicked
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.props.icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(googleMaterialIcon, {
                class: "card-content__icon",
                props: {
                            iconName: __props.props.icon,
                        }
              }, null, 8, ["props"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, _toDisplayString(__props.props.title), 1)
          ]),
          (__props.props.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", null, _toDisplayString(__props.props.description), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(MaterialShapedButton, {
          props: {
                        icon: 'arrow_forward',
                    },
          class: "msb sn-msc-button-on-minor-card"
        })
      ])
    ])
  ]))
}
}

})